import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "D:\\b\\baczonedz\\node_modules\\next\\dist\\client\\app-dir\\link.js");
